import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { ShieldAlert, ArrowLeft, Home } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';

const AccessRestrictedPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();

  const formatRole = (role) => {
    if (!role) return '';
    return role.split('_').map(word => 
      word.charAt(0).toUpperCase() + word.slice(1)
    ).join(' ');
  };

  const requestedPage = location.state?.requiredAccess || 'this page';

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4" data-testid="access-restricted-page">
      <Card className="border-slate-200 max-w-md w-full">
        <CardContent className="pt-8 pb-8">
          <div className="flex flex-col items-center text-center">
            {/* Icon */}
            <div className="w-16 h-16 rounded-full bg-slate-100 flex items-center justify-center mb-6">
              <ShieldAlert className="h-8 w-8 text-slate-400" />
            </div>

            {/* Title */}
            <h1 className="text-xl font-semibold tracking-tight text-slate-900 mb-2">
              Access Restricted
            </h1>

            {/* Message */}
            <p className="text-sm text-slate-500 mb-2">
              You do not have permission to access this area.
            </p>

            <p className="text-xs text-slate-400 mb-6">
              Your current role ({formatRole(user?.role)}) does not include access to {requestedPage}.
              Contact your administrator if you need access.
            </p>

            {/* Actions */}
            <div className="flex gap-3">
              <Button
                variant="outline"
                size="sm"
                className="gap-2"
                onClick={() => navigate(-1)}
                data-testid="go-back-button"
              >
                <ArrowLeft className="h-4 w-4" />
                Go Back
              </Button>
              <Button
                size="sm"
                className="gap-2 bg-slate-900 hover:bg-slate-800"
                onClick={() => navigate('/dashboard')}
                data-testid="go-dashboard-button"
              >
                <Home className="h-4 w-4" />
                Dashboard
              </Button>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default AccessRestrictedPage;
